import { sendCode } from "@/apis/common";
import { checkBindPhoneNumber } from "@/apis/user";
import { DialogLocal } from "@/components/Dialog";
import { useUserInfoStore } from "@/stores/userInfo";
import { Form, Toast } from "antd-mobile";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

export const useSetup = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [userinfo, setUserInfo] = useUserInfoStore()((state) => [
    state.userInfo,
    state.setUserInfo,
  ]);
  const isBindPwd = useMemo(() => {
    return userinfo.isEnteredPassword;
  }, [userinfo.isEnteredPassword]);

  const sendSMS = async () => {
    const values = form.getFieldsValue();
    const result = await sendCode({
      phoneNumber: values.phoneNumber,
      codeType: "bindPhoneNumber",
    });
    if (result.ok) {
      if (process.env.NODE_ENV === "development") {
        form.setFieldsValue({
          smsCode: result.data,
        });
      }
      return Promise.resolve(true);
    } else {
      Toast.show(result.msg);
      return Promise.resolve(false);
    }
  };

  const onSubmit = async () => {
    const values = form.getFieldsValue();
    if (!/^1[3456789]\d{9}$/.test(values.phoneNumber)) {
      return Toast.show("请输入合法的手机号码");
    }
    if (!values.smsCode) return Toast.show("请输入短信验证码");
    const result = await checkBindPhoneNumber({
      phoneNumber: values.phoneNumber,
      smsCode: values.smsCode,
    });

    if (result.ok) {
      setUserInfo({ isEnteredPhoneNumber: 1, phone: values.phoneNumber });
      Toast.show(result.msg);
      if (!isBindPwd) {
        return DialogLocal({
          content: "请绑定密码",
          onConfirm: () => {
            navigate("/user_pay_psw", { replace: true });
          },
        });
      }
      navigate(-1);
    } else {
      Toast.show(result.msg);
    }
  };
  return {
    onSubmit,
    form,
    sendSMS,
  };
};
